import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from '../../../util/types';
import { FormattedMessage } from '../../../util/reactIntl';
import { Menu, MenuLabel, MenuContent, MenuItem, InlineTextButton, Icon } from '../..';
import classNames from 'classnames';

import css from './ControlMenu.module.css';

const USE_ARROW = false;
const CONTENT_POSITION = 'left';

const ControlMenu = props => {
  const {
    className,
    rootClassName,
    isPinned,
    isOwn,
    isReply,
    canPinComment,
    deleteCommentInProgress,
    deleteCommentError,
    onDeleteComment,
    onEditComment,
    onPinComment,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const deleteButtonDisabled = deleteCommentInProgress || deleteCommentError;

  return (
    <Menu className={classes} useArrow={USE_ARROW} contentPosition={CONTENT_POSITION}>
      <MenuLabel className={css.menuLabel}>
        <Icon name="more" />
      </MenuLabel>
      <MenuContent className={css.menuContent}>
        <MenuItem
          key="ControlMenu.pin"
          className={css.menuItem}
          isHidden={isReply || !canPinComment}
        >
          <InlineTextButton className={css.menuItemButton} type="button" onClick={onPinComment}>
            {isPinned ? (
              <FormattedMessage id="Comments.unpin" />
            ) : (
              <FormattedMessage id="Comments.pin" />
            )}
          </InlineTextButton>
        </MenuItem>
        <MenuItem key="ControlMenu.edit" className={css.menuItem} isHidden={!isOwn}>
          <InlineTextButton className={css.menuItemButton} type="button" onClick={onEditComment}>
            <FormattedMessage id="Comments.edit" />
          </InlineTextButton>
        </MenuItem>
        <MenuItem key="ControlMenu.delete" className={css.menuItem} isHidden={!isOwn}>
          <InlineTextButton
            className={css.menuItemButton}
            type="button"
            onClick={onDeleteComment}
            disabled={deleteButtonDisabled}
          >
            <FormattedMessage id="Comments.delete" />
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  );
};

ControlMenu.defaultProps = {
  className: null,
  rootClassName: null,
  isPinned: false,
  isOwn: false,
  isReply: false,
  canPinComment: false,
  deleteCommentInProgress: false,
  deleteCommentError: null,
  onDeleteComment: null,
  onEditComment: null,
  onPinComment: null,
};

const { func, string, bool } = PropTypes;

ControlMenu.propTypes = {
  className: string,
  rootClassName: string,
  isPinned: bool,
  isOwn: bool,
  isReply: bool,
  canPinComment: bool,
  deleteCommentInProgress: bool,
  deleteCommentError: propTypes.error,
  onEditComment: func,
  onDeleteComment: func,
  onPinComment: func.isRequired,
};

export default ControlMenu;
